import { useMutation } from 'react-query';
import { IErrorObject } from '../../services/types';
import iagService from '../service/iag.service';
import { AxiosResponse } from 'axios';

export const useInitSubmission = () => {
  return useMutation<AxiosResponse<{ submission: string }>, IErrorObject>(
    async () => {
      return await iagService.InitSubmission();
    },
    {
      onSuccess: data => {
        const response = data.data;
        const submissionId = response.submission;
        if (submissionId) {
          window.location.href = `/app/submission/${submissionId}/view`;
          return;
        }
      },
      onError(error) {},
    },
  );
};
